import { render } from "./GameTile.vue?vue&type=template&id=107ca57d&scoped=true"
import script from "./GameTile.vue?vue&type=script&lang=js"
export * from "./GameTile.vue?vue&type=script&lang=js"

import "./GameTile.vue?vue&type=style&index=0&id=107ca57d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-107ca57d"]])

export default __exports__